// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__Zl8U3","row":"ProcedureTreatmentSummary_row__1Bx0k"};